/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CommonDateTime } from "../../Api/commonDateTime";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import ReusableTable from "../UserInformation/ReusableTable";


const PaymentManagement = () => {
  const { websocket } = useContext(WebSocketContext);
  const { paymentList, search, userId, userList ,accessToken,formDate,toDate} = useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(1);
  const [optionsRegion, SetOptionsRegion] = useState(() => userList?.list?.filter((elm) => elm?.is_active)?.map((item, index) => ({ key: item.id, value: item?.id, label: item?.username })));
  

  useEffect(() => {  
      let param = {
          "transmit": "single",
          "url": "user_list",
          "request": {
            "status": true,
            "limit": "10000000",
            "page_no": 1,
            "search": "",
            "order_by": "-updated_at"
          }
        }
        wsSend_request(websocket, param)}, []);
  
  useEffect(() => {
    const param = {
      "transmit": "single",
      "url": "payment_list",
      "request": {
        "limit": "20",
        "page_no": search ? 1 : currentPage,
        "search": search || "",
        "user_id": userId || "",
        "order_by": "-updated_at"
      }
    };
    if (formDate && toDate) {
      param.request.from_date = CommonDateTime(formDate, "YYYY-MM-DD", "hide")+" "+CommonDateTime(formDate, "HH:mm", "show");
      const formattedToDate = CommonDateTime(toDate, "YYYY-MM-DD", "hide") + " " +
      (CommonDateTime(toDate, "HH:mm", "show") === "00:00" ? "23:59" : CommonDateTime(toDate, "HH:mm", "show"));
      param.request.to_date = formattedToDate;

    }
    wsSend_request(websocket, param);
  }, [websocket, currentPage, search, userId,formDate,toDate]);




  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
const headers = [
  { name: "Date & Time", key: "dateTime" },
  { name: "Transaction Id", key: "transactionId" },
  { name: "User Id", key: "userId" },
  { name: "Amount", key: "amount" },
  { name: "Status", key: "status" },
  { name: "Payment Method", key: "paymentMethod" },
  { name: "Payment Channel", key: "paymentChannel" }
];


      const renderRow = (payment, index,visibleColumns) => {
          return(
          <React.Fragment key={payment?.id}>
                          <tr key={payment.id} className="user-management-table-detail">
                           {visibleColumns?.includes("dateTime")&&<td style={{ cursor: "default" }}>
                           {moment(payment.created_at).format("YYYY-MM-DD HH:mm:ss")}
                           </td>} 
                            {visibleColumns?.includes("transactionId")&&<td style={{ cursor: "default" }}>{payment.transaction_id}</td>}
                            {visibleColumns?.includes("userId")&&<td style={{ cursor: "default" }}>{payment?.user_code || "-"}</td>}
                            {visibleColumns?.includes("amount")&&<td style={{ cursor: "default" }}>{`Rm ${parseFloat(payment.total_amount).toFixed(2)}`}</td>}
                            {visibleColumns?.includes("status")&&
                                    <td className='Vertical_align'>
                         <div style={{ height:"24px",color: "black",background:payment.status==="paid" ? "#B6EFBB":"#F7ABAB",borderRadius:"4px",padding:"5px",textAlign:"center",textTransform:"capitalize" }}>
                           {payment.status}
                         </div>
        </td>
                            }
                            {visibleColumns?.includes("paymentMethod")&&<td style={{ cursor: "default" }}>{payment.payment_method || "-"}</td>}
                            {visibleColumns?.includes("paymentChannel")&&<td style={{ cursor: "default" }}>{payment.payment_channel || "-"}</td>}
                          </tr>
  
        </React.Fragment>
      );
  
      }

  return (
    <>
    <ReusableTable
        headers={headers}
        data={paymentList?.list || []}
        paginationObject={paymentList?.pagination}
        renderRow={renderRow}
        filters={{
          fromDate: true,
          toDate: true,
          period: false,
          search: true,
          searchPlaceholder: "Search by User ID",
          // Revenue Monster id,
          userSelect: true,
          userOptions:optionsRegion,
          export: true,
          reset:true,
        }}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
       />
    </>
  );
};

export default PaymentManagement;
